import { lazyRouteComponent } from '@tanstack/react-router'

/**
 * Code-split the heavy page routes: each becomes its own chunk fetched on navigation, and never
 * fetched at all for a user whose RouteAccessBoundary blocks the page. The shell, login, and the
 * small not-found and access-denied pages stay eager, so first paint does not wait on a chunk.
 */
export const ActionSettingsPage = lazyRouteComponent(
	() => import('@/app/pages/Actions/ActionSettingsPage'),
	'ActionSettingsPage',
)
export const AnomaliesPage = lazyRouteComponent(() => import('@/app/pages/AnomaliesPage'), 'AnomaliesPage')
export const AssetsPage = lazyRouteComponent(() => import('@/app/pages/Actions/AssetsPage'), 'AssetsPage')
export const OtaCampaignsPage = lazyRouteComponent(
	() => import('@/app/pages/Actions/OtaCampaignsPage'),
	'OtaCampaignsPage',
)
export const RemoteCommandsPage = lazyRouteComponent(
	() => import('@/app/pages/Actions/RemoteCommandsPage'),
	'RemoteCommandsPage',
)
export const RulesPage = lazyRouteComponent(() => import('@/app/pages/Actions/RulesPage'), 'RulesPage')
export const AuditLogsPage = lazyRouteComponent(() => import('@/app/pages/AuditLogsPage'), 'AuditLogsPage')
export const DashboardDisplayPage = lazyRouteComponent(
	() => import('@/app/pages/Dashboards/DashboardDisplayPage'),
	'DashboardDisplayPage',
)
export const DashboardsPage = lazyRouteComponent(() => import('@/app/pages/DashboardsPage'), 'DashboardsPage')
export const DbcParserManagementPage = lazyRouteComponent(
	() => import('@/app/pages/DbcParserManagementPage'),
	'DbcParserManagementPage',
)
export const DeviceManagementPage = lazyRouteComponent(
	() => import('@/app/pages/DeviceManagementPage'),
	'DeviceManagementPage',
)
export const ExportersPage = lazyRouteComponent(() => import('@/app/pages/Exporters/ExportersPage'))
export const ProcessorsPage = lazyRouteComponent(() => import('@/app/pages/Processors/ProcessorsPage'))
export const OrganizationMetersLayout = lazyRouteComponent(
	() => import('@/app/pages/Organizations/Meters/MetersPage'),
	'OrganizationMetersLayout',
)
export const OrganizationMetersList = lazyRouteComponent(
	() => import('@/app/pages/Organizations/Meters/MetersPage'),
	'OrganizationMetersList',
)
export const OrganizationBillingPage = lazyRouteComponent(
	() => import('@/app/pages/Organizations/OrganizationBillingPage'),
)
export const SessionRulesPage = lazyRouteComponent(() => import('@/app/pages/SessionRulesPage'), 'SessionRulesPage')
export const SessionsFeedPage = lazyRouteComponent(() => import('@/app/pages/SessionsFeedPage'), 'SessionsFeedPage')
export const ApiKeysSettingsPage = lazyRouteComponent(() => import('@/app/pages/Settings/ApiKeysSettingsPage'))
export const MetadataPage = lazyRouteComponent(() => import('@/app/pages/Settings/Metadata/MetadataPage'))
export const DeviceStatePage = lazyRouteComponent(() => import('@/app/pages/Settings/DeviceState/DeviceStatePage'))
export const OrganizationGeneralPage = lazyRouteComponent(
	() => import('@/app/pages/Settings/OrganizationGeneralPage'),
	'OrganizationGeneralPage',
)
export const ProjectGeneralPage = lazyRouteComponent(
	() => import('@/app/pages/Settings/ProjectGeneralPage'),
	'ProjectGeneralPage',
)
export const ProjectModulesPage = lazyRouteComponent(
	() => import('@/app/pages/Settings/ProjectModulesPage'),
	'ProjectModulesPage',
)
export const QuotasPage = lazyRouteComponent(() => import('@/app/pages/Settings/Quotas/QuotasPage'), 'QuotasPage')
export const RoleSettingsPage = lazyRouteComponent(() => import('@/app/pages/Settings/Role/RoleSettingsPage'))
export const SettingsPage = lazyRouteComponent(() => import('@/app/pages/Settings/SettingsPage'), 'SettingsPage')
export const UsersSettingsPage = lazyRouteComponent(() => import('@/app/pages/Settings/UsersSettingsPage'))
export const StreamsPage = lazyRouteComponent(() => import('@/app/pages/StreamsPage'))
export const SubscriberGroupsPage = lazyRouteComponent(
	() => import('@/app/pages/SubscriberGroups/SubscriberGroupsPage'),
)
export const SystemNotificationsPage = lazyRouteComponent(
	() => import('@/app/pages/SystemNotifications/SystemNotificationsPage'),
	'SystemNotificationsPage',
)
export const TerminalPage = lazyRouteComponent(() => import('@/app/pages/TerminalPage'), 'TerminalPage')
export const WelcomePage = lazyRouteComponent(() => import('@/app/pages/WelcomePage'), 'WelcomePage')
